__turbopack_context__.v({
  "container": "error-report-module-scss-module__r0X20a__container",
  "container__buttons": "error-report-module-scss-module__r0X20a__container__buttons",
  "container__close": "error-report-module-scss-module__r0X20a__container__close",
  "container_sended": "error-report-module-scss-module__r0X20a__container_sended",
  "fileInputHidden": "error-report-module-scss-module__r0X20a__fileInputHidden",
  "fileInputLabel": "error-report-module-scss-module__r0X20a__fileInputLabel",
  "text": "error-report-module-scss-module__r0X20a__text",
  "text_accent": "error-report-module-scss-module__r0X20a__text_accent",
  "text_file": "error-report-module-scss-module__r0X20a__text_file",
  "text_heading": "error-report-module-scss-module__r0X20a__text_heading",
  "textarea": "error-report-module-scss-module__r0X20a__textarea",
  "textarea__button": "error-report-module-scss-module__r0X20a__textarea__button",
  "textarea__file": "error-report-module-scss-module__r0X20a__textarea__file",
  "textarea__fileInfo": "error-report-module-scss-module__r0X20a__textarea__fileInfo",
  "textarea__fileMeta": "error-report-module-scss-module__r0X20a__textarea__fileMeta",
  "textarea__fileName": "error-report-module-scss-module__r0X20a__textarea__fileName",
  "textarea__fileSize": "error-report-module-scss-module__r0X20a__textarea__fileSize",
});
